﻿var UserBetsPlugin = (function (Communicator)
{
    'use strict';

    var version = 1;

    function init(pushServerConnectionPointUrl)
    {
        Communicator.Start(pushServerConnectionPointUrl, 'PushUserBets');
    }

    function sendMessageToPush(messageType, messageParams)
    {
        Communicator.SendMessage(messageType, JSON.stringify(messageParams));

    }
    return {
        Version: version,
        Run: init,
        sendMessageToPush: sendMessageToPush
    }
})(Communicator);

window.UserBetsPlugin = UserBetsPlugin;
